/**
 * Lazy-loaded motion-v utilities.
 *
 * Usage pattern:
 *   1. Wrap a layout ancestor with <LazyMotion :features="loadMotionFeatures">
 *   2. Create element-specific components via the Motion proxy:
 *        Motion.div;
 *        Motion.aside;
 *      ... and so on
 *   3. Components render elements immediately with correct initial styles;
 *      animations activate once features load asynchronously.
 *
 * This keeps the motion animation engine out of the initial bundle
 * while still rendering the correct first paint.
 */
import { LazyMotion, m, AnimatePresence } from 'motion-v';

export { LazyMotion };
export { m as Motion };
// Orchestrates enter/exit when elements mount/unmount (e.g. v-if). Wrap the
// conditional Motion element and give it an `exit` variant so it animates out
// instead of disappearing instantly.
export { AnimatePresence };

export const loadMotionFeatures = () =>
  import('motion-v').then(({ domAnimation }) => domAnimation);
